import {
    KeywordAction,
    KeywordActionTypes,
    SearchKeyword
} from "../interfaces/context/searchContextInterfaces";

const defaultState = {
    userInputValue: "",
    userSelectedKeyword: null
};

export const keywordReducer = (state: SearchKeyword, action: KeywordAction) => {
    switch (action.type) {
    case KeywordActionTypes.updateKeyword: {
        const updatedState = {
            ...state,
            ...action.payload
        };
        return updatedState;
    }
    case KeywordActionTypes.resetKeyword: {
        return defaultState;
    }
    default: {
        return state;
    }
    }
};
